// src/hooks/usePageTracking.js (修正後)
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
// ★ 変更点: firebase/analyticsから直接インポートするのではなく、
//           前回作成した堅牢なfirebase.jsから安全なゲッター関数をインポートします。
import { getAnalyticsInstance } from '../firebase';
import { logEvent } from 'firebase/analytics';

const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    // ★ 変更点: useEffectの中で、毎回安全にインスタンスを取得します。
    // これにより、このフックがいつ呼び出されても、初期化が完了した
    // インスタンスを確実に取得できます。
    const analytics = getAnalyticsInstance();

    // analyticsインスタンスが利用可能（初期化完了済み）な場合のみ、
    // logEventを実行します。
    if (analytics) {
      logEvent(analytics, 'page_view', {
        page_path: location.pathname + location.search,
        page_title: document.title, // ページのタイトルも一緒に送る
      });
      console.log(`📈 GA4 page_view: ${location.pathname + location.search}`);
    }
  }, [location]); // locationが変わるたびにこのeffectを実行
};

export default usePageTracking;